export default {
  default_browser_tag: 'FoodAmigos - Bestil online',
  seo: {
    title: '{{name}} - bestil mad online i {{city}}',
    description: '{{name}} i {{city}}. Officiel menu. Spar penge og bestil online.',
  },
};
